import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getReminderAnalyses = asyncThunkWrapper({ 
  model: 'reminderAnalyses', 
  action: 'getReminderAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/reminder_flow/reminder_analyses', { params });

    return response.data;
  } 
});
export const getReminderAnalysis = asyncThunkWrapper({ 
  model: 'reminderAnalyses', 
  action: 'getReminderAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = ['id', 'result', 'status', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/reminder_analyses/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const clearLocalReminderAnalyses = createAction('reminderAnalyses/clearLocalReminderAnalyses');
export const clearLocalActiveReminderAnalysis = createAction('reminderAnalyses/clearLocalActiveReminderAnalysis');